import "@/App.css";
import { Suspense, lazy } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import SmoothScroll from "@/components/landing/SmoothScroll";

// Legal / secondary pages are code-split so the landing page ships the
// smallest possible bundle (better LCP/TTI). The landing page itself is
// eagerly imported since it is the most-requested entry point.
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("@/pages/TermsOfService"));
const DataDeletion = lazy(() => import("@/pages/DataDeletion"));
const Contact = lazy(() => import("@/pages/Contact"));

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-[var(--bg)] text-white">
        <SmoothScroll>
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-screen bg-[var(--bg)]" aria-hidden="true" />}>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/data-deletion" element={<DataDeletion />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Landing />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </SmoothScroll>
      </div>
    </HelmetProvider>
  );
}

export default App;
